/**
 * GetMeal store サービス
 *
 */
import { Injectable } from '@angular/core';
import { SupportClass } from '@lib/components/support-class';
import { select, Store } from '@ngrx/store';
import { filter, map, Observable, pairwise } from 'rxjs';
import {
  GetMealState,
  GetMealStore,
  resetGetMeal,
  selectGetMealState,
  setGetMealFromApi,
} from '@common/store/get-meal';
import { GetMealRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';

/**
 * GetMeal store サービス
 *
 * store情報
 * @param getMealData @see GetMealState
 */
@Injectable()
export class GetMealStoreService {
  constructor(private _store: Store<GetMealStore>, private api: ServicingApiService) {}
  public getMeal$() {
    return this._store.pipe(
      select(selectGetMealState),
      filter((data) => !!data)
    );
  }

  private _result$ = this._store.pipe(
    select(selectGetMealState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  get success$(): Observable<GetMealState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  get failure$(): Observable<GetMealState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  public resetGetMeal() {
    this._store.dispatch(resetGetMeal());
  }

  public setGetMealFromApi(request: GetMealRequest) {
    this._store.dispatch(
      setGetMealFromApi({
        call: this.api.getMealPost(request),
      })
    );
  }
  destroy(): void {
    this.clearMealResult();
  }
  public clearMealResult() {
    this._store.dispatch(resetGetMeal());
  }
}
